module.exports = __webpack_public_path__ + "static/media/StatsRadio_DataDisseminationRules.d4b7cc10.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/en/StatsRadio_DataDisseminationRules.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/en/StatsRadio_DataDisseminationRules.pdf
// module chunks = 18